import { render, staticRenderFns } from "./CompanyDesktopMultiPackages.vue?vue&type=template&id=b6bd0f16"
import script from "./CompanyDesktopMultiPackages.vue?vue&type=script&lang=js"
export * from "./CompanyDesktopMultiPackages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports